import { render, staticRenderFns } from "./Refill.vue?vue&type=template&id=36b358aa&scoped=true"
import script from "./Refill.vue?vue&type=script&lang=js"
export * from "./Refill.vue?vue&type=script&lang=js"
import style0 from "./Refill.vue?vue&type=style&index=0&id=36b358aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b358aa",
  null
  
)

export default component.exports